import { render, staticRenderFns } from "./HeaderSearchComponent.vue?vue&type=template&id=57d21741"
import script from "./HeaderSearchComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderSearchComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports